import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-topic-offer",
    on: {
      "touchstart": function touchstart($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "offer-explanation"
  }, [!_vm.isMultipleDetails ? _c('div', {
    staticClass: "explanation-content",
    class: {
      'no-commission': !_vm.hasCommission
    },
    on: {
      "click": function click($event) {
        _vm.slideUpRule(), _vm.newAnchorPoint('点击商详', '说明'), _vm.reportUserAnchors('500098');
      }
    }
  }, [_c('div', {
    staticClass: "cel-2"
  }, [_vm.couponDetail && _vm.couponDetail.labelSwitch && _vm.couponDetail.labelSwitch.newLabelSwitch && _vm.couponDetail.labelSwitch.newLabelSwitch.length ? _vm._l(_vm.couponDetail.labelSwitch.newLabelSwitch, function (item) {
    return _c('div', {
      key: item.name,
      staticClass: "new-unit-label"
    }, [_c('div', {
      staticClass: "label-icon"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "label-txt"
    }, [_vm._v(_vm._s(item.label))])]);
  }) : _vm._e()], 2)]) : _vm._e()]), _vm.hmsTopic && !_vm.fxbInviteCode ? _c('div', {
    staticClass: "activity-specialty",
    on: {
      "click": _vm.onClickHmsTopic
    }
  }, [_c('ycf-image', {
    staticClass: "activity-label",
    attrs: {
      "src": "/srcv2/images/activity_label.png"
    }
  }), _c('div', {
    staticClass: "activity-text",
    style: {
      'margin-top': _vm.isIos ? 0 : '4px'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.hmsTopic.description) + "\n    ")]), _c('span', {
    staticClass: "more-activity"
  }, [_vm._v("更多")])], 1) : _vm.topicList.length && !_vm.fxbInviteCode ? _c('div', {
    staticClass: "activity-specialty",
    on: {
      "click": _vm.slideUpTopicBox
    }
  }, [_c('ycf-image', {
    staticClass: "activity-label",
    attrs: {
      "src": "/srcv2/images/activity_label.png"
    }
  }), _c('div', {
    staticClass: "activity-text",
    style: {
      'margin-top': _vm.isIos ? 0 : '4px'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.topicList[0].entranceTitle || _vm.topicList[0].title) + "\n    ")]), _vm.topicList.length > 1 ? _c('span', {
    staticClass: "more-activity"
  }, [_vm._v("更多")]) : _vm._e()], 1) : _vm._e(), _vm.loadTopicBox ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showTopicBox,
      expression: "showTopicBox"
    }],
    staticClass: "Layer-FullScreen topic-box",
    on: {
      "click": _vm.slideDownTopicBox
    }
  }, [_c('div', {
    staticClass: "main-bottom",
    class: {
      'slide-down': _vm.topicBoxSlideDown
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', {
    staticClass: "titie"
  }, [_vm._v("\n        专场活动"), _c('i', {
    staticClass: "btn-close",
    on: {
      "click": _vm.slideDownTopicBox
    }
  })]), _c('div', {
    staticClass: "topic-list"
  }, _vm._l(_vm.topicList, function (topic, index) {
    return _c('div', {
      key: index,
      staticClass: "topic-item",
      on: {
        "click": function click($event) {
          return _vm.goTopicIndexPage(topic);
        }
      }
    }, [_c('div', {
      staticClass: "topic-icon"
    }, [_c('img', {
      attrs: {
        "src": "//qiniu-cdn7.jinxidao.com/dvb/frontv2/images/special_activity_icon.png"
      }
    }), _c('span', [_vm._v("活动" + _vm._s(_vm.SectionToChinese(index + 1)))])]), _c('span', {
      staticClass: "topic-name"
    }, [_vm._v(_vm._s(topic.title))])]);
  }), 0)])]) : _vm._e(), _vm.loadRuleDescription ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showRuleDescription,
      expression: "showRuleDescription"
    }],
    staticClass: "Layer-FullScreen rule-description",
    on: {
      "click": _vm.slideDownRule
    }
  }, [_c('div', {
    staticClass: "main-bottom",
    class: {
      'slide-down': _vm.ruleSlideDown
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', {
    staticClass: "head-title"
  }, [_vm._v("规则说明")]), _c('div', {
    staticClass: "main-scroll"
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("限购规则")]), _vm.couponDetail.restrictionDetails ? _c('div', {
    staticClass: "txt-p"
  }, [_vm.couponDetail.restrictionDetails.weChat ? _c('p', [_vm._v("\n            每个微信号" + _vm._s(_vm.couponDetail.restrictionDetails.weChat.day ? _vm.couponDetail.restrictionDetails.weChat.day + "天内" : "") + "限购" + _vm._s(_vm.couponDetail.restrictionDetails.weChat.limit + (_vm.couponDetail.baseValueUnit || "份")) + "\n          ")]) : _vm._e(), _vm.couponDetail.restrictionDetails.phone ? _c('p', [_vm._v("\n            每个联系人手机号" + _vm._s(_vm.couponDetail.restrictionDetails.phone.day ? _vm.couponDetail.restrictionDetails.phone.day + "天内" : "") + "限购" + _vm._s(_vm.couponDetail.restrictionDetails.phone.limit + (_vm.couponDetail.baseValueUnit || "份")) + "\n          ")]) : _vm._e(), _vm.couponDetail.restrictionDetails.idCard ? _c('p', [_vm._v("\n            每个证件号码" + _vm._s(_vm.couponDetail.restrictionDetails.idCard.day ? _vm.couponDetail.restrictionDetails.idCard.day + "天内" : "") + "限购" + _vm._s(_vm.couponDetail.restrictionDetails.idCard.limit + (_vm.couponDetail.baseValueUnit || "份")) + "\n          ")]) : _vm._e()]) : _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("无购买份数限制")]), _c('p', {
    staticClass: "txt-h"
  }, [_vm._v("退款规则")]), _vm.couponDetail.refundDesc ? _c('div', {
    staticClass: "txt-p"
  }, _vm._l(_vm.couponDetail.refundDesc.changeRuleDetail, function (changeRule, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n            " + _vm._s(changeRule) + "\n          ")]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "main-foot"
  }, [_c('span', {
    on: {
      "click": _vm.slideDownRule
    }
  }, [_vm._v("完成")])])])]) : _vm._e(), !_vm.isOtherBrowser && !_vm.isShop && !_vm.isAlipayMini ? _c('ycf-new-comer', {
    ref: "newComer",
    attrs: {
      "item-id": _vm.goodId,
      "source": _vm.channel,
      "from": "1"
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };